import React from 'react';

import { AddCircle } from '@mui/icons-material';
import { alpha, useTheme } from '@mui/material';

interface CreateEnvironmentPlaceholderNodeProps {
	data: {
		onCreate: () => void;
	};
}

export default function CreateEnvironmentPlaceholderNode({ data }: CreateEnvironmentPlaceholderNodeProps) {
	const { onCreate } = data;
	const theme = useTheme();
	const defaultShadow = `0 2px 8px ${alpha(theme.palette.common.black, 0.3)}`;
	const hoverShadow = `0 4px 14px ${alpha(theme.palette.primary.main, 0.24)}`;

	return (
		<div
			style={{
				background: theme.palette.background.paper,
				border: `2px dashed ${theme.palette.primary.light}`,
				borderRadius: '8px',
				padding: '32px 24px',
				minWidth: '200px',
				textAlign: 'center',
				boxShadow: defaultShadow,
				transition: 'all 0.2s',
				cursor: 'pointer',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				gap: '16px',
			}}
			onClick={onCreate}
			onMouseEnter={(e) => {
				e.currentTarget.style.boxShadow = hoverShadow;
				e.currentTarget.style.transform = 'translateY(-2px)';
				e.currentTarget.style.background = alpha(theme.palette.primary.main, 0.14);
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.boxShadow = defaultShadow;
				e.currentTarget.style.transform = 'translateY(0px)';
				e.currentTarget.style.background = theme.palette.background.paper;
			}}
		>
			<AddCircle sx={{ fontSize: 48, color: 'primary.light' }} />
			<div>
				<div style={{ fontSize: '18px', fontWeight: 'bold', color: theme.palette.text.primary, marginBottom: '4px' }}>Create Environment</div>
				<div style={{ fontSize: '14px', color: theme.palette.text.secondary }}>Click here to create your first environment</div>
			</div>
		</div>
	);
}
